import SidebarLayout from '../../components/templates/SidebarLayout.js';
import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from "react-bootstrap";
import { useLocation, useHistory } from "react-router-dom";
import EditPassword from "./EditPassword";
import DeletionActions from "./DeletionActions";
import useAuthApi from "../../hooks/useAuthApi";

function CustomToggle({ children, eventKey, handleClick }) {
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    handleClick();
  });

  return (
    <div className='settings__accordian-toggle border-0' type="button" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}

function Privacy(props) {
  const [activeKey, setActiveKey] = useState(0);
  const location = useLocation();
  const history = useHistory();
  const [userId, setUserId] = useState(location.state ? location.state.userId : null);
  const authApi = useAuthApi()

  useEffect(() => {
    getUserId();
  }, []);

  function getUserId() {
    if(userId == null) {
      authApi.get('users/users').then(data => {
        setUserId(data.data.id);
      }).catch(function(error) {
        console.log(error)
        history.push({
          pathname: "/signin" });
      });
    } 
  }
  
  var PrivacyCard = (title, body, index) => {
    let cardClass = activeKey === index ? "active settings__privacy-card-title" : "settings__privacy-card-title"
    return (
      <Card className={cardClass} key={index}>
        <CustomToggle
          as={Card.Header}
          eventKey={index}
          handleClick={() => {
            if (activeKey === index) {
              setActiveKey(null);
            } else {
              setActiveKey(index);
            }
          }}
        >
          <span>{title}</span>
          <span>{activeKey === index ? " -" : " +"}</span>
        </CustomToggle>
        <Accordion.Collapse eventKey={index} className='border-0'>
          <Card.Body className='settings__privacy-card-body'>
            {body}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    );
  }


  const PrivacyAndSecurity = () => {
    const privacyInformation = [{title: 'Terms and Conditions', body: 'Terms and Conditions'},
                                {title: 'Our Privacy Policy', body: 'Our Privacy Policy'},
                                {title: 'HIPPA Compliance Policy', body: 'HIPPA Compliance Policy'}]

    let privacyInformationCards = privacyInformation.map((item, index) => PrivacyCard(item.title, item.body, "privacy-" + index));


    return (
      <div className='settings__privacy-and-security settings-page'>
        <p className='settings__page-title'>Privacy and security settings</p>

        <EditPassword userId={userId} />

        <DeletionActions userId={userId} />

      </div>
    );
  }

  return (
    <SidebarLayout 
      sidebarClasses='settings__side-bar'
      content={PrivacyAndSecurity()}
      contentClasses='settings__content'
      userStatus='logged-in'
      showFooter={true}
    />
  );
}

export default Privacy;
